import React, {Component,Suspense,lazy} from 'react';
import { connect } from 'react-redux';
import {Link, Switch, Route, Redirect, BrowserRouter as Router } from 'react-router-dom';
import {Container} from 'reactstrap';
import ASHeader from '../../components/Header/ASHeader'
import PhoenixFooter from '@lesofi/phoenix-react-js/lib/PhoenixFooter' 
import Sidebar from '../../components/Sidebar/'
import Aside from '../../components/Aside/'
import ErrorBoundary from '@lesofi/phoenix-react-js/lib/ErrorBoundary'
import Spinner from '@lesofi/phoenix-react-js/lib/Spinner'
import Analytics from 'react-router-ga' 

import * as actions from '@lesofi/phoenix-sdk-js/lib/admin/redux/auth/actions';

const Dashboard = lazy(()=>import('../../views/Dashboard/')) 
const VdpRuns = lazy(()=> import('../../views/VdpRuns'))
const VdpRunDetails = lazy(()=>import('../../views/VdpRuns/VdpRunDetails'))
const ProjApolloRun = lazy(()=> import('../../views/ProjectApollo/ProjApolloRun') )
const ProjApolloHdrDataset = lazy(()=> import('../../views/ProjectApollo/ProjApolloHdrDataset'))
const ProjApolloItemDataset = lazy(()=> import('../../views/ProjectApollo/ProjApolloItemDataset'))
const ProjApolloXml = lazy(()=> import('../../views/ProjectApollo/ProjApolloXml'))
const ApolloXmlCountReports = lazy(()=> import('../../views/Reports/ApolloXmlCountReports'))
const BellerophonXmlCountReports = lazy(()=> import('../../views/Reports/BellerophonXmlCountReports'))
const ApolloXmlCountBatches = lazy(()=> import('../../views/Reports/ApolloXmlCountBatches'))
const BellerophonXmlCountBatches = lazy(()=> import('../../views/Reports/BellerophonXmlCountBatches'))
const ApolloXmlCountBatchWorkers = lazy(()=> import('../../views/Reports/ApolloXmlCountBatchWorkers'))
const BellerophonXmlCountBatchWorkers = lazy(()=> import('../../views/Reports/BellerophonXmlCountBatchWorkers'))
const Workers = lazy(()=> import('../../views/Workers'))
const AddOrEditWorkerForm = lazy(()=> import('../../views/Workers/AddOrEditWorkerForm')) 
const CrowdWorkers = lazy(()=> import('../../views/crowdWorkers/CrowdWorkers')) 
const AssignNewCrowdWorker = lazy(()=> import('../../views/crowdWorkers/AssignNewCrowdWorker')) 
const GorgonViewExtractedData = lazy(()=> import('../../views/ProjectGorgon/GorgonViewExtractedData')) 
const GorgonForms = lazy(()=> import('../../views/ProjectGorgon/GorgonForms')) 
const GorgonFormQuestions = lazy(()=>import('../../views/ProjectGorgon/GorgonFormQuestions')) 
const AdmProjectBillableWorkflows = lazy(()=> import('../../views/Adm/AdmProjectBillableWorkflows')) 
const AdmTasksCountReports = lazy(()=> import('../../views/Adm/AdmTasksCountReports')) 
const AdmWorkersTasksCountReports = lazy(()=>import('../../views/Adm/AdmWorkersTasksCountReports')) 
const LoginTacComponent = lazy(()=> import('../../components/rewrap/LoginTacComponent'))
const GoogleLoginComponent = lazy(()=> import('../../components/rewrap/GoogleLoginComponent'))
const TaskDistsComponent = lazy(()=> import('../../components/rewrap/TaskDistsComponent'))
const TaskBatchRunsComponent = lazy(()=> import('../../components/rewrap/TaskBatchRunsComponent'))
const TaskBatchResultsetsComponent = lazy(()=> import('../../components/rewrap/TaskBatchResultsetsComponent'))
const TaskResultsetLineItemsComponent = lazy(()=> import('../../components/rewrap/TaskResultsetLineItemsComponent'))

const PrivateRoute = ({component: Component, authed, ...rest}) => {  
  return (    
       <Route {...rest} render={(props) => authed === true 
         ? <Component {...props} /> 
         : <Redirect to={{pathname: '/login', state: {from: props.location }}} />} />  
)}

const isLoggedIn = props => {
  if (props.auth.jwtToken){
    return true;
  } else {
    return false;
  }
}

const Full = props =>  {  
    return (
     <Router> 
      <div className="app">
        <ASHeader profile={props.auth.profile} logout={props.logout} />
        <div className="app-body">
          {isLoggedIn(props)?(<Sidebar {...props}/>):null}
          <main className="main">
            <Container fluid>
              <Analytics id="UA-93381200-4">
                <ErrorBoundary fallback={<div className='container'><div><p>Something went wrong</p></div></div>}>
                  <Suspense fallback={<Spinner />}>
                    <Switch>
                      <Route path="/login" name="Login" component={GoogleLoginComponent}/>
                      <Route path="/loginWithTAC" name="Login" component={LoginTacComponent}/> 
                      <PrivateRoute authed={isLoggedIn(props)} path='/dashboard' component = {Dashboard} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/vdpRuns' component = {VdpRuns} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/vdpRunDetails' component = {VdpRunDetails} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/projApolloRuns' component = {ProjApolloRun} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/projApolloRuns/:crowdGroupId' component = {ProjApolloRun} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/projApolloHdrDatasets/:jobRunId' component = {ProjApolloHdrDataset} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/projApolloItemDatasets/:vdpHdrDatasetId' component = {ProjApolloItemDataset} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/projApolloXmls/:vdpHdrDatasetId' component = {ProjApolloXml} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/apolloXmlCountReports' component = {ApolloXmlCountReports} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/apolloXmlCountBatches/:apolloXmlReportId' component = {ApolloXmlCountBatches} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/apolloXmlCountBatchWorkers/:apolloXmlCountBatchId' component = {ApolloXmlCountBatchWorkers} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/bellerophonXmlCountReports' component = {BellerophonXmlCountReports} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/bellerophonXmlCountBatches/:bellerophonXmlReportId' component = {BellerophonXmlCountBatches} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/bellerophonXmlCountBatchWorkers/:bellerophonXmlCountBatchId' component = {BellerophonXmlCountBatchWorkers} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/workers' component = {Workers} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/addOrEditWorkerForm' component = {AddOrEditWorkerForm} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskDists/crowdWorkers/:crowdGroupId' component = {CrowdWorkers} />
                      <PrivateRoute authed={isLoggedIn(props)} path='/assignNewCrowdWorker' component = {AssignNewCrowdWorker} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/gorgonViewExtractedData/:gorgonResultsetId' component = {GorgonViewExtractedData} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/gorgonViewExtractedData/:gorgonResultsetId/:isProd' component = {GorgonViewExtractedData} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/gorgonForms/:dataType' component = {GorgonForms} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/gorgonFormQuestions/:gorgonFormId/:dataType/:formNum' component = {GorgonFormQuestions} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/admProjectBillableWorkflows' component = {AdmProjectBillableWorkflows} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/admTasksCountReports/:admProjectBillableWorkflowId/:projectName/:taskName/:workflowSeq' component = {AdmTasksCountReports} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/admWorkersTasksCountReports/:admTasksCountReportId/:admProjectBillableWorkflowId/:projectName/:taskName/:workflowSeq/:yyyymmPrefix' component = {AdmWorkersTasksCountReports} />
                      
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/' component = {TaskDistsComponent} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskBatchRuns/:taskType/:workflowType/:crowdGroupId' component = {TaskBatchRunsComponent} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskBatchResultsets/:runId' component = {TaskBatchResultsetsComponent} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskResultsetLineItems/:resultsetId' component = {TaskResultsetLineItemsComponent} />
                      
                      <PrivateRoute authed={isLoggedIn(props)} path='/apolloStatistic' component = {Dashboard} />
                      <Route render={() => (
                        <div className='container'>
                        <h3>Are we lost or what?</h3>
                        </div>
                      )}/>
                    </Switch>
                  </Suspense>
                </ErrorBoundary>
              </Analytics>
            </Container>
          </main>
          <Aside />
        </div>
        <PhoenixFooter />
      </div>
     </Router> 
    );
}

const mapStateToProps = (state, ownProps) => {
  return state;
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    logout: () => {
      dispatch(actions.logout())
    },
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Full);



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js